
import Vue from "vue";
import AppExcelMapper from "@/components/excel-mapper/ExcelMapper.vue";
import { ContactCSVImportExistingContactHandling, ContactService } from "@/utils/services/contact-service";

export default Vue.extend({
	data(){
		return {
			cols: [] as string[],
		};
	},
	props: {
		service: {
			type: Object as ()=>ContactService,
			required: true
		}
	},
	methods: {
		async onExcelMapperFile(file:File){
			await this.service.importContactsExcel(file, ContactCSVImportExistingContactHandling.UPDATE);
		}
	},
	async created(){
		this.cols = await this.service.getImporterAllowedCols();
	},
	components: {
		AppExcelMapper
	}
});
